import { render, staticRenderFns } from "./login.vue?vue&type=template&id=0a512088&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=0a512088&prod&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=0a512088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a512088",
  null
  
)

export default component.exports